module.exports = "/img/23.cd2de7.webp";